import { AbstractControl, ValidationErrors } from '@angular/forms';

export function taxCodeValidator(control: AbstractControl): ValidationErrors | null {
  return validate(control.value);
}

function validate(pi: string): ValidationErrors | null {
  if (!pi) {
    return null;
  }
  // if (pi.length === 0) {
  //   return { length: true }; // Empty
  // }
  if (pi.length !== 11) {
    return { length: true }; // Invalid length
  }
  if (!/^[0-9]{11}$/.test(pi)) {
    return { pattern: true }; // Invalid characters
  }
  let s = 0;
  for (let i = 0; i < 11; i++) {
    let n = pi.charCodeAt(i) - '0'.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    if ((i & 1) === 1) {
      n *= 2;
      if (n > 9) {
        n -= 9;
      }
    }
    s += n;
  }
  if (s % 10 !== 0) {
    return { checksum: true }; // Invalid checksum
  }
  return null;
}
